import { LogOut, Sprout, Settings, ShieldCheck, CalendarClock, HelpCircle } from "lucide-react";

const IconBtn = ({ testId, title, onClick, children, hoverClass = "hover:text-[#5d8a73] hover:border-[#81B29A]" }) => (
  <button data-testid={testId} onClick={onClick} title={title}
    className={`relative h-9 w-9 rounded-full bg-white border border-slate-200 flex items-center justify-center text-slate-500 transition-colors ${hoverClass}`}>
    {children}
  </button>
);

export default function LayoutHeader({ user, meetingsActive, onHome, onMeetings, onHelp, helpEngaged, onSecurity, onSettings, onLogout }) {
  return (
    <header className="sticky top-0 z-30 bg-[#F9F9F7]/85 backdrop-blur-md border-b border-slate-200/60 no-print">
      <div className="max-w-6xl mx-auto px-5 md:px-8 h-16 flex items-center justify-between">
        <button data-testid="brand-home-btn" onClick={onHome} className="flex items-center gap-2.5 group">
          <span className="h-9 w-9 rounded-2xl bg-[#81B29A] flex items-center justify-center text-white shadow-sm group-hover:scale-105 transition-transform">
            <Sprout size={20} strokeWidth={2} />
          </span>
          <span className="font-['Outfit'] font-bold text-lg text-slate-800 tracking-tight">
            Bloom<span className="text-[#81B29A]">Track</span>
          </span>
        </button>

        <div className="flex items-center gap-4">
          <button data-testid="nav-meetings-btn" onClick={onMeetings} title="Meetings"
            className={`hidden sm:inline-flex items-center gap-1.5 text-sm font-semibold font-['Outfit'] rounded-full px-3.5 py-1.5 transition-colors ${
              meetingsActive ? "bg-[#6C8EBF]/15 text-[#4f6f9c]" : "text-slate-500 hover:text-[#4f6f9c] hover:bg-[#6C8EBF]/10"
            }`}>
            <CalendarClock size={16} /> Meetings
          </button>
          <div className="text-right hidden sm:block">
            <p className="text-sm font-semibold text-slate-700 font-['Outfit'] leading-tight">{user?.name}</p>
            <p className="text-xs text-slate-400 capitalize">{user?.role}</p>
          </div>
          <IconBtn testId="help-open-btn" title="How BloomTrack works" onClick={onHelp}>
            <HelpCircle size={16} />
            {!helpEngaged && (
              <span data-testid="help-new-pulse" className="absolute -top-0.5 -right-0.5 flex h-2.5 w-2.5">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#81B29A] opacity-75" />
                <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-[#5d8a73]" />
              </span>
            )}
          </IconBtn>
          <IconBtn testId="account-security-btn" title="Account & security" onClick={onSecurity}>
            <ShieldCheck size={16} />
          </IconBtn>
          <IconBtn testId="school-settings-btn" title="School details" onClick={onSettings}>
            <Settings size={16} />
          </IconBtn>
          <IconBtn testId="logout-btn" title="Sign out" onClick={onLogout} hoverClass="hover:text-red-500 hover:border-red-200">
            <LogOut size={16} />
          </IconBtn>
        </div>
      </div>
    </header>
  );
}
